<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'DIRECTORY-SEARCH-CHANNELS'" [breadcrumb]="''" [count]=""
    icon="fa-search-location">
</app-breadcrumb>
<app-provider-search [allowSelection]="false" [allowFacilitySearch]="true"></app-provider-search>